package fr.frux.feature.map

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.lifecycle.Lifecycle
import androidx.lifecycle.compose.LocalLifecycleOwner
import androidx.lifecycle.repeatOnLifecycle

/**
 * Le point bleu suit la personne tant que l'app est au premier plan (#734).
 *
 * Monte avec [MapSurface], donc avec la carte permanente (ADR 0009), et non avec `MapScreen` : un
 * changement d'onglet ne doit ni couper ni relancer le GPS. STARTED = visible, donc collecte
 * annulee en arriere-plan (le GPS s'arrete) et reprise au retour, ce qui rafraichit le point. Le
 * ViewModel suspend en plus le suivi tant que la carte n'est pas visible.
 */
@Composable
internal fun FollowUserLocationEffect(viewModel: MapViewModel) {
    val lifecycle = LocalLifecycleOwner.current.lifecycle
    LaunchedEffect(viewModel, lifecycle) {
        lifecycle.repeatOnLifecycle(Lifecycle.State.STARTED) { viewModel.followUserLocation() }
    }
}
